import { useEffect, useRef } from 'react'
import { evaluateLabV2 } from 'api/labV2'
import { setLabV2Evaluation } from 'actions/SystemActions'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import config from 'constants/config'
import { shallowEqual, useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { getLabEvaluateAttributes } from 'lib/labV2/getLabEvaluateAttributes'
import { getOptimizelyFeatureFlagVariation } from 'lib/optimizely/optimizelyUtils'

export default function useLabV2EvaluationRequest(): void {
  const dispatch = useAppDispatch()
  const accessToken = useAppSelector(state => state.auth.accessToken)
  const memberId = useAppSelector(state => state.auth.account.memberId)
  const labV2Enabled = useAppSelector(state => getOptimizelyFeatureFlagVariation(
    state,
    OptimizelyFeatureFlags.enableLabV2FeatureFlag,
  ))
  const attributes = useAppSelector(getLabEvaluateAttributes, shallowEqual)
  const accessTokenRef = useRef(accessToken)
  const attributesRef = useRef(attributes)
  const skippedServerDocument = useRef(false)
  accessTokenRef.current = accessToken
  attributesRef.current = attributes

  useEffect(() => {
    if (!labV2Enabled) {
      return
    }

    // The server already evaluated this document. Login and signup still evaluate.
    if (config.SSR_DISABLED !== true && !skippedServerDocument.current) {
      skippedServerDocument.current = true
      return
    }

    evaluateLabV2(accessTokenRef.current, labV2Enabled, attributesRef.current).then(configs => {
      if (configs) {
        dispatch(setLabV2Evaluation(configs))
      }
    }).catch(() => undefined)
  }, [dispatch, labV2Enabled, memberId])
}
